import * as THREE from 'three'
import Experience from '../Experience.js'
import  gsap  from "gsap"
import makeDom from '../utils/MakeDom.js'
//for line23
// import * as BufferGeometryUtils from '../../../node_modules/three/examples/jsm/utils/BufferGeometryUtils.js';
// import { LineSegmentsGeometry } from '../../../node_modules/three/examples/jsm/lines/LineSegmentsGeometry.js';
// import { LineSegments2 } from '../../../node_modules/three/examples/jsm/lines/LineSegments2.js';
// import { LineMaterial } from '../../../node_modules/three/examples/jsm/lines/LineMaterial.js';

// import { OutsideEdgesGeometry } from '../EdgesGeometry/OutsideEdgesGeometry.js';
// import { ConditionalEdgesGeometry } from '../EdgesGeometry/ConditionalEdgesGeometry.js';
// import { ConditionalEdgesShader } from '../EdgesGeometry/ConditionalEdgesShader.js';
// import { ConditionalLineSegmentsGeometry } from '../EdgesGeometry/Lines2/ConditionalLineSegmentsGeometry.js';
// import { ConditionalLineMaterial } from '../EdgesGeometry/Lines2/ConditionalLineMaterial.js';
// import { ColoredShadowMaterial } from '../EdgesGeometry/ColoredShadowMaterial.js';
//end line 23

import { Vector3 } from 'three'

export default class Divano
{
    constructor(divano,opa)
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.sceneGroup = this.experience.sceneGroup
        // this.sceneGroupLines= new THREE.Group()
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug
        this.canvas= this.experience.canvas
        this.camera=this.experience.camera
        this.sizes=this.experience.sizes
        this.defaultColor=this.experience.defaultColor
        if (!this.defaultColor) this.defaultColor = 'combotexblu'
        this.sizes.on('resize', () =>
        {
            this.resize()
        })
        this.name=divano

        // Debug
        if(this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('divano')
        }
        // Resource

        this.resource = this.resources.items[divano]
        this.opacity={value:opa}
        this.zPos={value:0}



        if(this.debug.active)
        {
            this.debugFolder
                .add(this.zPos, 'value')
                .name('posizione z')
                .min(-5)
                .max(5)
                .step(0.01)
            //     ,
            // this.debugFolder
            //     .add(this.pointLight.position, 'y')
            //     .name('pointlight y')
            //     .min(-20)
            //     .max(20)
            //     .step(0.01),
            // this.debugFolder
            //     .add(this.pointLight.position, 'z')
            //     .name('pointlight z')
            //     .min(-20)
            //     .max(20)
            //     .step(0.01)
        }


        // const USPattern= new RegExp('_')
        this.colore=[]

        this.setModel()
        // console.log('pippocol')
        this.changeColor('combo'+this.defaultColor)
        // console.log('combo'+this.defaultColor)
        // this.changeColor('texneutra',1)
        // console.log(this.edgesModel)
    
    }

    setModel()
    {



        //converti in basicmaterial


        this.resource.scene.traverse((child) =>{
            if ( ! child.isMesh ) return;
            
            //prova standard mat
            
            var prevMaterial = child.material;
            child.material = new THREE.MeshStandardMaterial();
            THREE.MeshStandardMaterial.prototype.copy.call( child.material, prevMaterial );
            child.material.alphaTest=0.001

            // segue basicmaterial funzionante
            // var prevMaterial = child.material;
            // child.material = new THREE.MeshBasicMaterial();
            // THREE.MeshBasicMaterial.prototype.copy.call( child.material, prevMaterial );
            // child.material.alphaTest=0.001
            //FINE prova standard mat
            

            // child.material.transparent=true
            // console.log(child)
          });
        // this.resource.scene.traverse((child) =>
        // {
        //     if(child instanceof THREE.Mesh)
        //     {
        //         child.castShadow = true
        //         child.receiveShadow = true

        //     }
        // })

        this.model = this.resource.scene
        this.myModel=[...this.model.children]
        // this.misure=[]
        // const AOPattern= new RegExp('AO-')
        this.SHDPattern= new RegExp('SH-')
        const MCPattern= new RegExp('MC-')
        this.MISPattern= new RegExp('MIS-')
        const DISTPattern= new RegExp('DIST-')
        // const DCOLPattern= new RegExp('COMBO-')
        const chromeMaterialMatcap=new THREE.MeshMatcapMaterial()
        chromeMaterialMatcap.matcap=this.resources.items.matcapTexture
        // this.borderMaterialMatcap=new THREE.MeshMatcapMaterial()
        // this.borderMaterialMatcap.matcap=this.resources.items.border
        this.distancePoint=[]
        let res=null
        let res2=null
        // this.AOmap={}
        // this.AOuv={}

        this.dist3dpoint=[]
        // this.colore=Array
        this.misureVisible=false



        for (const child of this.myModel){
            // res2= child.name.split(SHDPattern)
            // if (res2.length>1){
            // res2= child.name.split(SHDPattern)
            if (this.SHDPattern.test(child.name)){
                child.material.transparent=true
                child.material.opacity=this.opacity.value
                // child.material=ombraDivano
                child.material.map.encoding=THREE.LinearEncoding
                child.renderOrder=2
                child.finalposition=child.position.y
                if (this.opacity.value) this.sceneGroup.add(child)
            }
            // else if (DCOLPattern.test(child.name)){
            //     this.defaultColor='combo'+child.name.split(DCOLPattern)[1]
            //     console.log(this.defaultColor)
            // }
            else if (MCPattern.test(child.name)){
                // child.renderOrder=2
                child.material.transparent=true
                child.material=chromeMaterialMatcap
                child.material.opacity=this.opacity.value
                child.finalposition=child.position.y
                if (this.opacity.value) this.sceneGroup.add(child)
                // this.sceneGroup.add(child)
                // console.log(child)
            }
            else if (this.MISPattern.test(child.name)){
                child.material.transparent=true
                child.material.opacity=0
                this.misure=child
            }
            else if (DISTPattern.test(child.name)){
                const distance=child.name.split(DISTPattern)
                const USPattern= new RegExp('_')
                const space= '/\+/'
                const nome=distance[1].split(USPattern)
                nome[2]=nome[2].replace(/\*/g,'/')
                nome[2]=nome[2].replace(/\+/g,' ')

                const point=new makeDom({
                    tag:'div',
                    class:['MIS-'+nome[0],'MISURE','hided'],
                    parent:this.canvas.parentNode,
                    content:''
                })
                const span1=new makeDom({
                    tag:'div',
                    class:['label'],
                    parent:point.element,
                    content:nome[1]
                })
                const span2=new makeDom({
                    tag:'div',
                    class:['misura'],
                    parent:span1.element,
                    content:nome[2]
                })
                this.distancePoint[distance[1]]={position:child,element:point}
                this.dist3dpoint.push(child)
            }
            else if(child instanceof THREE.Mesh){
                //  console.log(child.name)
                if (child.name=='COLORE1') {
                    // child.material.map.minFilter = THREE.LinearMipmapNearestFilter
                    // child.material.map.magFilter = THREE.LinearMipmapNearestFilter
                    this.remapMaterialUVs(child.material,{roughnessMap:'texcoord_2',normalMap:'texcoord_2'})
                    child.material.flatShading = false
                    if(this.debug.active)
                    {
                        this.debugFolder
                            .add(child.material, 'roughness')
                            .name('roughness')
                            .min(0)
                            .max(3)
                            .step(0.01)
                    }
                    
                    this.colore[0]=child
                    // console.log(child.material.map)
                }
                if (child.name=='COLORE2') {
                    // child.material.map.minFilter = THREE.LinearFilter
                    // child.material.map.minFilter = THREE.LinearMipmapNearestFilter
                    this.remapMaterialUVs(child.material,{roughnessMap:'texcoord_2',normalMap:'texcoord_2'})
                    child.material.flatShading = false
                    this.colore[1]=child
                    // console.log(child.material)
                }
                child.material.format = THREE.RGBAFormat
                child.renderOrder=4
                child.finalposition=child.position.y
                if (this.opacity.value) this.sceneGroup.add(child)
                // this.sceneGroup.add(child)

            // }else{
            //     for (const secChild of child.children){
            //         if(secChild instanceof THREE.Mesh){
            //             secChild.geometry.attributes.uv2=this.AOuv[res[0]]
            //             secChild.material.aoMap=this.AOmap[res[0]]
            //             secChild.material.format = THREE.RGBAFormat
            //         }
            //     }
            }
        }
        this.updateMat()
    }
    changeColor(cCombo){
        // console.log(this.colore[1])
        // console.log(cCombo)
        if(this.resources.combo[cCombo]){
            // console.log(this.resources.combo[cCombo][0])
            var nomeCol1=this.resources.combo[cCombo][0]
            var nomeCol2=this.resources.combo[cCombo][1]
            if (this.colore[0]){
                this.colore[0].material.map=this.resources.items[nomeCol1]
                this.colore[0].material.aoMapIntensity=this.resources.aoint[nomeCol1]
                this.colore[0].material.roughness=this.resources.rough[nomeCol1]
                this.colore[0].material.lightMap=this.colore[0].material.aoMap
                this.colore[0].material.lightMapIntensity=this.resources.lmint[nomeCol1]
                this.colore[0].material.map.wrapS=THREE.RepeatWrapping
                this.colore[0].material.map.wrapT=THREE.RepeatWrapping
                this.colore[0].material.map.minFilter = THREE.NearestMipmapNearestFilter
                this.colore[0].material.needsUpdate = true
                if (this.resources.rgb[nomeCol1]){
                    this.colore[0].material.color.r = this.resources.rgb[nomeCol1][0]
                    this.colore[0].material.color.g = this.resources.rgb[nomeCol1][1]
                    this.colore[0].material.color.b = this.resources.rgb[nomeCol1][2]
                }else{
                    this.colore[0].material.color.r = 1
                    this.colore[0].material.color.g = 1
                    this.colore[0].material.color.b = 1
                    console.log( this.resources.rgb[nomeCol2])
                }
            }
            if (this.colore[1]){
                this.colore[1].material.map=this.resources.items[nomeCol2]
                this.colore[1].material.aoMapIntensity=this.resources.aoint[nomeCol2]
                this.colore[1].material.roughness=this.resources.rough[nomeCol2]
                this.colore[1].material.lightMap=this.colore[1].material.aoMap
                this.colore[1].material.lightMapIntensity=this.resources.lmint[nomeCol2]
                this.colore[1].material.map.wrapS=THREE.RepeatWrapping
                this.colore[1].material.map.wrapT=THREE.RepeatWrapping
                this.colore[1].material.map.minFilter = THREE.NearestMipmapNearestFilter
                
                if (this.resources.rgb[nomeCol2]){
                    this.colore[1].material.color.r = this.resources.rgb[nomeCol2][0]
                    this.colore[1].material.color.g = this.resources.rgb[nomeCol2][1]
                    this.colore[1].material.color.b = this.resources.rgb[nomeCol2][2]
                }else{
                    this.colore[1].material.color.r = 1
                    this.colore[1].material.color.g = 1
                    this.colore[1].material.color.b = 1
                    console.log( this.resources.rgb[nomeCol2])
                }
                if (this.resources.invert[nomeCol2]){
                    this.colore[1].material.normalScale.y = 10
                    this.colore[1].material.normalScale.x = 1
                    // console.log(this.colore[1].material)
                }else{
                    this.colore[1].material.normalScale.y = -1
                    this.colore[1].material.normalScale.x = 1
                    
                }

                
                this.colore[1].material.needsUpdate = true
            }
        }else console.log('PIPPO')

    
    }
    showMeasure(show){
        if (this.misure){
            if (show){
                // console.log(this.camera.cameraGroup)
                this.sceneGroup.add(this.misure)
                for (const punto of this.dist3dpoint)
                    this.sceneGroup.add(punto)
                gsap.to(this.misure.material,{opacity:1,duration:1.5,delay:0,ease:'power1.inOut',overwrite:true})
                if (this.distancePoint){
                    for (const punto of Object.entries(this.distancePoint)){
                        punto[1].element.show()
                    }
                }
                this.misureVisible=true
                this.resize()

            }
            else{
                gsap.to(this.misure.material,{opacity:0,duration:0.5,ease:'power1.inOut',overwrite:true})
                // this.misure.material.opacity=0
                if (this.distancePoint){
                    for (const punto of Object.entries(this.distancePoint)){
                        punto[1].element.hide()
                    }
                }
                this.misureVisible=false
            }
        }
    }
    setMisure(){
        if (this.distancePoint && this.misureVisible){
            for (const punto of Object.entries(this.distancePoint)){
                
                const scrPos= new THREE.Vector3
                scrPos.setFromMatrixPosition(punto[1].position.matrixWorld)
                scrPos.project(this.camera.instance)
                const translateX=(scrPos.x)/2 * this.sizes.width
                const translateY=-(scrPos.y)/2 * this.sizes.height
                punto[1].element.element.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`
            }
        }
    }
    resize(){
        if (this.distancePoint && this.misureVisible){
            // console.log(this.distancePoint)
            for (const punto of Object.entries(this.distancePoint)){
                
                const height=this.sizes.height/2
                punto[1].element.element.style.top = `${height}px`
            }
        }
        this.setMisure()
        // this.updatePos()
        // console.log(this.distancePoint)
        // this.misure.style.top='50px'
    }

    updateMat(){
        // this.myModel.traverse((child) =>
        //siamo in divanojs
        for (const child of this.myModel)
        {
            // if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial)
            if(child instanceof THREE.Mesh && child.material && !this.MISPattern.test(child.name))
            {
                //  console.log(child)
                child.material.opacity = this.opacity.value
                child.material.needsUpdate = true
            }
        }
    }
    // resetTrasp(valore){
    //     // this.myModel.traverse((child) =>
    //     //siamo in divanojs
    //     for (const child of this.myModel)
    //     {
    //         // if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial)
    //         if(child instanceof THREE.Mesh && child.material && !this.MISPattern.test(child.name)&& !this.SHDPattern.test(child.name))
    //         {
    //             //  console.log(child)
    //             child.material.transparent = valore
    //             // child.material.opacity = this.opacity.value
    //             child.material.needsUpdate = true
    //         }
    //     }
    // }
    // hideOLD(){
    //     // console.log(this.opacity)
    //     this.resetTrasp(true)
    //     gsap.to(this.opacity,{value:0,duration:0.1,ease:'power1.inOut',onUpdate:()=>{this.updateMat()},onComplete:()=>{this.disposeMesh()}})
    // }
    hide(){
        for (const child of this.myModel)
        {
            if(child instanceof THREE.Mesh && this.SHDPattern.test(child.name))
            {
                child.material.transparent=true
                child.material.opacity=1
                gsap.to(child.material,{opacity:0,duration:1,ease:'power1.inOut'})
            }
            if(child instanceof THREE.Mesh && child.material && !this.MISPattern.test(child.name) && !this.SHDPattern.test(child.name))
            {
                 gsap.to(child.position,{y:-1,duration:1,ease:'power1.inOut',onComplete:()=>{this.disposeMesh()}})
            }
        }
    }
    show(delay){
        for (const child of this.myModel)
        {
            if(child instanceof THREE.Mesh && this.SHDPattern.test(child.name))
            {
                child.material.transparent=true
                child.material.opacity=0
                this.sceneGroup.add(child)
                gsap.to(child.material,{opacity:1,duration:1,ease:'power1.inOut'})
            }
            if(child instanceof THREE.Mesh && child.material && !this.MISPattern.test(child.name)&& !this.SHDPattern.test(child.name))
            {
                child.material.opacity = 1
                this.sceneGroup.add(child)
                child.position.y=-1
                gsap.to(child.position,{y:child.finalposition,duration:1,ease:'power1.inOut'})
            }
        }
    }
    // showOLD(delay){
    //     setTimeout(()=>{
    //         for (const child of this.myModel){
    //             if(child instanceof THREE.Mesh && !this.MISPattern.test(child.name) )
    //             {
    //                 // console.log(child)
    //                 this.sceneGroup.add(child)
    //                 child.material.transparent = true
    //                 child.material.opacity = this.opacity.value
    //                 // child.material.needsUpdate = true
    //             }
    //             // console.log(child.name)
    //         }

    //     },delay)
    //     gsap.to(this.opacity,{value:1,duration:0.1,delay:0,ease:'power1.inOut',onUpdate:()=>{this.updateMat()},onComplete:()=>{this.resetTrasp(false)}})
        
    // }
    disposeMesh(){
        for (const child of this.myModel){
            this.sceneGroup.remove(child)
            // console.log(child.name)
        }

        // console.log('rimosso??')

    }







//remap material
        // NOTE Usage:
        //  remapMaterialUVs(child.material, {
        //    'emissiveMap': 'texcoord_2', // <- fourth UV map
        //    'roughnessMap': 'texcoord_3' // <- fifth UV map
        //  });

        remapMaterialUVs = (material, remapUVs, {
            uvAttributePrefix,
            uvAttributeOffset
        } = {}) => {
            const _uvAttributePrefix = uvAttributePrefix || 'texcoord_';
            const _uvAttributeOffset = 2;
            
            material.customProgramCacheKey = () => Math.random();
            material.onBeforeCompile = (shader, context) => {  
            const resolveIncludes = (shader) => {
                // NOTE Straight from three/WebGLProgram.js
                const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
        
                return shader.replace(includePattern, (match, include) => {
                const string = THREE.ShaderChunk[include];
        
                if (!string) {
                    return;
                }
        
                return resolveIncludes(string);
                });
            };
        
            let maxTexCoordIndex = 0;
            const texCoordSwaps = [];
        
            Object.entries(remapUVs).forEach(([ textureType, uvMap ]) => {
                if (!uvMap.startsWith(_uvAttributePrefix)) {
                console.warn('Invalid UVMap name', uvMap);
        
                return;
                }
        
                const texCoordIndex = parseFloat(uvMap.split(new RegExp(`${_uvAttributePrefix}\\D*`, 'gi')).join(''));
        
                maxTexCoordIndex = Math.max(texCoordIndex, maxTexCoordIndex);
                texCoordSwaps[textureType] = texCoordIndex;
            });
        
            if (maxTexCoordIndex - 1 <= 0) {
                return;
            }
        
            shader.vertexShader = shader.vertexShader.replace(`#include <uv2_pars_vertex>`, `
                ${Array(maxTexCoordIndex - 1).fill(0).map((_, index) => `
                attribute vec2 ${_uvAttributePrefix}${index + _uvAttributeOffset};
                varying vec2 vTexCoord${index + _uvAttributeOffset};
                `).join('\n')}
        
                #include <uv2_pars_vertex>
            `).replace(`#include <uv2_vertex>`, `
                ${Array(maxTexCoordIndex - 1).fill(0).map((_, index) => `
                vTexCoord${index + _uvAttributeOffset} = ( vec3( ${_uvAttributePrefix}${index + _uvAttributeOffset}, 1 ) ).xy;
                `).join('\n')}
        
                #include <uv2_vertex>
            `);
        
            shader.fragmentShader = shader.fragmentShader.replace(`#include <uv2_pars_fragment>`, `
                ${Array(maxTexCoordIndex - 1).fill(0).map((_, index) => `
                varying vec2 vTexCoord${index + _uvAttributeOffset};
                `).join('\n')}
        
                #include <uv2_pars_fragment>
            `);
        
            shader.vertexShader = resolveIncludes(shader.vertexShader);
            shader.fragmentShader = resolveIncludes(shader.fragmentShader);
        
            Object.entries(texCoordSwaps).forEach(([ textureType, texCoordIndex ]) => {
                shader.fragmentShader = shader.fragmentShader.replaceAll(
                `texture2D( ${textureType}, vUv )`,
                `texture2D( ${textureType}, vTexCoord${texCoordIndex} )`
                ).replaceAll(
                `texture2D( ${textureType}, vUv2 )`,
                `texture2D( ${textureType}, vTexCoord${texCoordIndex} )`
                );
            });
            };
        };
//fine remap material

  



}